import * as types from './action-types'

export const fetchShiftIssues = (shiftID: number) => ({
  type: types.SHIFT_ISSUES_FETCH_BEGIN,
  shiftID,
})
